import { render, staticRenderFns } from "./v-fake-door.vue?vue&type=template&id=05d278ea&"
import script from "./v-fake-door.vue?vue&type=script&lang=js&"
export * from "./v-fake-door.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports